var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronRightGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2639 26.8792C16.0989 26.6729 16.0112 26.446 16.0009 26.1985C15.9906 25.9509 16.0783 25.7343 16.2639 25.5486L21.7101 20.1024L16.233 14.6253C16.068 14.4603 15.9906 14.2385 16.0009 13.96C16.0112 13.6815 16.0989 13.4597 16.2639 13.2947C16.4702 13.0884 16.692 12.9904 16.9292 13.0007C17.1665 13.0111 17.3779 13.109 17.5636 13.2947L23.7215 19.4526C23.8246 19.5558 23.8969 19.6589 23.9381 19.7621C23.9794 19.8652 24 19.9787 24 20.1024C24 20.2262 23.9794 20.3397 23.9381 20.4428C23.8969 20.546 23.8246 20.6491 23.7215 20.7523L17.5945 26.8792C17.4089 27.0649 17.1923 27.1526 16.9447 27.1423C16.6972 27.1319 16.4702 27.0443 16.2639 26.8792Z",
    fill: "#98A2B3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightGrey);
export default "data:image/svg+xml,%3csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M16.2639 26.8792C16.0989 26.6729 16.0112 26.446 16.0009 26.1985C15.9906 25.9509 16.0783 25.7343 16.2639 25.5486L21.7101 20.1024L16.233 14.6253C16.068 14.4603 15.9906 14.2385 16.0009 13.96C16.0112 13.6815 16.0989 13.4597 16.2639 13.2947C16.4702 13.0884 16.692 12.9904 16.9292 13.0007C17.1665 13.0111 17.3779 13.109 17.5636 13.2947L23.7215 19.4526C23.8246 19.5558 23.8969 19.6589 23.9381 19.7621C23.9794 19.8652 24 19.9787 24 20.1024C24 20.2262 23.9794 20.3397 23.9381 20.4428C23.8969 20.546 23.8246 20.6491 23.7215 20.7523L17.5945 26.8792C17.4089 27.0649 17.1923 27.1526 16.9447 27.1423C16.6972 27.1319 16.4702 27.0443 16.2639 26.8792Z' fill='%2398A2B3'/%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };